customElements.get("text-overflow-toggle") || customElements.define("text-overflow-toggle", class extends HTMLElement {
  static observedAttributes=[ "disabled" ];
  #t;
  #e;
  #i;
  #s;
  #n;
  #o;
  #h=!1;
  #a;
  #l;
  #c;
  constructor() {
    super(), this.#t = this.querySelector('input[type="checkbox"]'), this.#e = this.#t?.nextElementSibling, 
    this.#i = this.#e?.nextElementSibling, this.#a = {
      collapsedDesktop: parseInt(this.dataset.collapsedDesktop || "6", 10),
      collapsedMobile: parseInt(this.dataset.collapsedMobile || "4", 10),
      lineHeight: parseFloat(this.dataset.lineHeight || "1.4"),
      breakpoint: parseInt(this.dataset.breakpoint || "1024", 10)
    }, this.#l = window.matchMedia(`(min-width: ${this.#a.breakpoint}px)`), this.#c = this.#l.matches ? "desktop" : "mobile";
  }
  connectedCallback() {
    this.#t && this.#e && this.#i && (getComputedStyle(this.#e).transition.includes("max-height") || (this.#e.style.transition = "max-height 300ms ease-out"), 
    this.#t.addEventListener("change", () => this.#r()), this.#l.addEventListener("change", () => this.#d()), 
    this.#g(), this.#p(), this.#u(), this.#m());
  }
  disconnectedCallback() {
    this.#s?.disconnect(), this.#l?.removeEventListener("change", () => this.#d()), 
    cancelAnimationFrame(this.#n), clearTimeout(this.#o);
  }
  attributeChangedCallback() {
    this.#g(), this.#p();
  }
  #b() {
    const t = "desktop" === this.#c ? this.#a.collapsedDesktop : this.#a.collapsedMobile;
    return (parseFloat(getComputedStyle(this.#e).fontSize) || 16) * this.#a.lineHeight * t;
  }
  #d() {
    const t = this.#l.matches ? "desktop" : "mobile";
    t !== this.#c && (this.#c = t, this.#t.checked || (this.#e.style.maxHeight = `${this.#b()}px`), 
    this.#m());
  }
  #m() {
    cancelAnimationFrame(this.#n), this.#n = requestAnimationFrame(() => {
      const t = this.#h, e = this.#e.style.maxHeight, i = this.#e.style.transition;
      this.#e.style.transition = "none", this.#e.style.maxHeight = "none";
      const s = this.#e.scrollHeight;
      this.#e.style.maxHeight = e, this.#e.offsetHeight, this.#e.style.transition = i;
      const n = this.#b(), o = (parseFloat(getComputedStyle(this.#e).fontSize) || 16) * this.#a.lineHeight;
      this.#h = s > n + o, t !== this.#h && (this.#g(), this.#p(), !this.#h && this.#t.checked && (this.#t.checked = !1, 
      this.#r()));
    });
  }
  #g() {
    const t = this.#h && !this.hasAttribute("disabled");
    Object.assign(this.#i.style, {
      opacity: t ? "1" : "0",
      pointerEvents: t ? "auto" : "none"
    }), this.#t.disabled = this.hasAttribute("disabled");
  }
  #p() {
    const t = this.#h && !this.#t.checked;
    Object.assign(this.#e.style, {
      maskImage: t ? "linear-gradient(to bottom, black 75%, transparent)" : "none",
      webkitMaskImage: t ? "linear-gradient(to bottom, black 75%, transparent)" : "none"
    });
  }
  #r() {
    const t = this.#t.checked, e = this.#b();
    if (this.#p(), t) {
      const t = this.#e.style.transition;
      this.#e.style.transition = "none", this.#e.style.maxHeight = "none";
      const i = this.#e.scrollHeight;
      this.#e.style.maxHeight = `${e}px`, this.#e.offsetHeight, this.#e.style.transition = t;
      const s = Math.min(600, Math.max(200, 10 * Math.sqrt(i)));
      this.#e.style.transitionDuration = `${s}ms`, requestAnimationFrame(() => {
        this.#e.style.maxHeight = `${i + 20}px`;
      }), this.dispatchEvent(new CustomEvent("toggle", {
        detail: {
          expanded: !0,
          height: i
        },
        bubbles: !0
      }));
    } else {
      const t = this.#e.scrollHeight, i = Math.min(600, Math.max(200, 10 * Math.sqrt(t)));
      this.#e.style.maxHeight = `${t}px`, this.#e.style.transitionDuration = `${i}ms`, 
      requestAnimationFrame(() => {
        this.#e.style.maxHeight = `${e}px`;
      }), this.dispatchEvent(new CustomEvent("toggle", {
        detail: {
          expanded: !1,
          height: e
        },
        bubbles: !0
      }));
    }
  }
  #u() {
    let t = this.#e.offsetWidth;
    this.#s = new ResizeObserver(() => {
      clearTimeout(this.#o), this.#o = setTimeout(() => {
        const e = this.#e.offsetWidth;
        Math.abs(e - t) > 1 && (t = e, this.#t.checked || (this.#e.style.maxHeight = `${this.#b()}px`), 
        this.#m());
      }, 16);
    }), this.#s.observe(this.#e);
  }
  toggle(t) {
    this.hasAttribute("disabled") || (this.#t.checked = t ?? !this.#t.checked, this.#r());
  }
  get expanded() {
    return this.#t.checked;
  }
  get overflowing() {
    return this.#h;
  }
});